import { Injectable } from "@angular/core";
import { ExternalSettings } from "src/app/common/services/external-settings/external-settings.interface";
import { Country } from "src/app/common/interfaces/country";

@Injectable({
  providedIn: 'root'
})
export class CountryUtilityService {

  private static countries: Country[] = [];

  constructor() { }

  /**
   * Initialize via ExternalSettingsService.initializeLibaries
   */
  static init(externalSettings: ExternalSettings) {
    CountryUtilityService.countries = externalSettings.countries;
  }

  static getCountry(code: string): Country | undefined {
    return CountryUtilityService.countries.find(value => value.code == code);
  }

  static getCountryName(code: string): string {
    return CountryUtilityService.getCountry(code)?.name ?? '';
  }

}

